import React from "react"
import { deliveryStatusMap, paymentStatusMap } from "data/static.items"
import { Icon } from "@blueprintjs/core"
import { orderStatusMap } from "data/orderStatuses"
import CustomCard from "components/Atoms/CustomCard"

const Statuses = ({ orderStatus, deliveryStatus, paymentStatus }) => {
  const ord = orderStatusMap[orderStatus]
  const dil = deliveryStatusMap[deliveryStatus]
  const pay = paymentStatusMap[paymentStatus]
  return (
    <div className="grid grid-cols-3 gap-4 mt-5 text-center vt-muted">
      <div className="col-span-1">
        <CustomCard className="h-full">
          <p>Order</p>
          <p className="vt-dark text-sm">{ord?.name}</p>
          <Icon
            icon={ord?.id === "CMP" ? "tick" : "dot"}
            intent={ord?.id === "CMP" ? "success" : "primary"}
          />
        </CustomCard>
      </div>
      <div className="col-span-1">
        <CustomCard className="h-full">
          <p>Payment</p>
          <p className="vt-dark text-sm">{pay?.name}</p>
          <Icon
            icon={pay?.id === "SUC" ? "tick" : "dot"}
            intent={pay?.id === "SUC" ? "success" : "primary"}
          />
        </CustomCard>
      </div>
      <div className="col-span-1">
        <CustomCard className="h-full">
          <p>Delivery</p>
          <p className="vt-dark text-sm">{dil?.name}</p>
          <Icon
            icon={dil?.id === "DLV" ? "tick" : "dot"}
            intent={dil?.id === "DLV" ? "success" : "primary"}
          />
        </CustomCard>
      </div>
    </div>
  )
}

export default Statuses
